import React from "react";
import "./topOfNav.style.sass";
import { Icon, Tooltip, Whisper } from "rsuite";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectBaseInfo } from "../../redux/site/site.selector";
import { AddIcon, ConvertToENNumber } from "../../script";
import RingLoader from "react-spinners/RingLoader";
import { css } from "@emotion/react";

const TopOfNav = ({ baseInfo }) => {
  const override = css`
    display: block;
    margin: 40px auto;
    border-color: red;
  `;

  const tooltip = (item) => <Tooltip>{item.name}</Tooltip>;
  return (
    <div className="top-of-nav">
      <div className="container-this">
        <div className="texts">
          {baseInfo
            ? JSON.parse(baseInfo[0].baseInfo).map((item, i) => (
                <a key={i} href={`tel:${ConvertToENNumber(item.value)}`}>
                  <p>
                    {item.key} : {item.value}
                  </p>
                </a>
              ))
            : null}
        </div>
        <div className="icons">
          {baseInfo ? (
            AddIcon(JSON.parse(baseInfo[0].social_networks)).map((item, i) => (
              <Whisper
                key={i}
                placement="bottom"
                trigger="hover"
                speaker={tooltip(item)}
              >
                <a href={item.href}>
                  <Icon icon={item.icon} />
                </a>
              </Whisper>
            ))
          ) : (
            <RingLoader css={override} size={35} color="#FF8F3C" />
          )}
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = createStructuredSelector({
  baseInfo: selectBaseInfo,
});
export default connect(mapStateToProps)(TopOfNav);
